import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'together-auction-dip-validate-fields',
    templateUrl: './validate-fields.component.html',
    styleUrls: ['./validate-fields.component.scss'],
    standalone: false
})
export class ValidateFieldsComponent implements OnInit {

  @Input() errorMsg: string;
  @Input() displayError: boolean;

  constructor() { }

  ngOnInit() {
  }

}
